import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "EquipmentDocuments";

type ItemDocumentParams = {
  equipment: string;
  fileTypeFilter?: string;
  includeFileSize?: boolean;
};

export const getDocumentsLinkedToEquipment = async (
  params: ItemDocumentParams
) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetEquipmentLinkedDocuments`,
    undefined,
    params
  );
};
